import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { MaterialModule } from './../../modules/material/material.module';
import { ArtisticCultureSelectionListModule } from './artistic-culture-selection-list/artistic-culture-selection-list.module';
import { BrandSelectionListModule } from './brand-selection-list/brand-selection-list.module';
import { ClaimSelectionListModule } from './claim-selection-list/claim-selection-list.module';
import { CustomFieldSelectionSearchModule } from './custom-field-selection-list/custom-field-selection-list.module';
import { DeviceTypeSelectionListModule } from './device-type-selection-list/device-type-selection-list.module';
import { EnumSelectionListModule } from './enum-selection-list/enum-selection-list.module';
import { MapPlacesGridSelectionListModule } from './map-places-grid-selection-list/map-places-grid-selection-list.module';
import { OrganizationConfirmedSafeIpSelectionListModule } from './organization-confirmed-safeIp-selection-list/organization-confirmed-safeIp-selection-list.module';
import { OrganizationSelectionListModule } from './organization-selection-list/organization-selection-list.module';
import { PhonebookSelectionListModule } from './phonebook-selection-list/phonebook-selection-list.module';
import { PrivateNumberSelectionListModule } from './private-number-selection-list/private-number-selection-list.module';
import { PublicPlaceSelectionListModule } from './public-place-selection-list/public-place-selection-list.module';
import { RoleSelectionListModule } from './role-selection-list/role-selection-list.module';
import { UserSelectionListModule } from './user-selection-list/user-selection-list.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    ReactiveFormsModule,
    TranslationModule,
    NgxMatSelectSearchModule,
    NgxMaterialTimepickerModule,
    SharePipesModule,
    ClaimSelectionListModule,
    CustomFieldSelectionSearchModule,
    EnumSelectionListModule,
    OrganizationSelectionListModule,
    PhonebookSelectionListModule,
    PrivateNumberSelectionListModule,
    RoleSelectionListModule,
    UserSelectionListModule,
    PublicPlaceSelectionListModule,
    BrandSelectionListModule,
    DeviceTypeSelectionListModule,
    OrganizationConfirmedSafeIpSelectionListModule,
    ArtisticCultureSelectionListModule,
    MapPlacesGridSelectionListModule,
  ],
  exports: [
    ClaimSelectionListModule,
    CustomFieldSelectionSearchModule,
    EnumSelectionListModule,
    OrganizationSelectionListModule,
    PhonebookSelectionListModule,
    PrivateNumberSelectionListModule,
    RoleSelectionListModule,
    UserSelectionListModule,
    PublicPlaceSelectionListModule,
    BrandSelectionListModule,
    DeviceTypeSelectionListModule,
    OrganizationConfirmedSafeIpSelectionListModule,
    ArtisticCultureSelectionListModule,
    MapPlacesGridSelectionListModule
  ]

})
export class SelectionListModule { }
